import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface GetEnrollmentTotalPaymentsParams {
  enrollmentId: string;
  studentId?: string;
  studioId?: string;
}

interface PaymentBreakdown {
  date: string;
  amount: number;
  isProrated: boolean;
  paymentNumber: number;
}

interface GetEnrollmentTotalPaymentsResponse {
  totalPayments: number;
  totalAmount?: number;
  payments?: PaymentBreakdown[];
  enrollmentId?: string;
  message?: string;
}

export const getEnrollmentTotalPayments = async ({
  enrollmentId,
  studentId,
  studioId,
}: GetEnrollmentTotalPaymentsParams) => {
  const params: Record<string, string> = {};
  if (studentId) params.studentId = studentId;
  if (studioId) params.studioId = studioId;

  const response = await baseAPI.get<GetEnrollmentTotalPaymentsResponse>(
    `/enrollments/${enrollmentId}/total-payments`,
    {
      params: Object.keys(params).length > 0 ? params : undefined,
    },
  );
  return response.data;
};

export const useGetEnrollmentTotalPayments = (
  params: GetEnrollmentTotalPaymentsParams,
  options?: { enabled?: boolean },
) => {
  return useQuery({
    queryKey: [
      KEYS.ENROLLMENT_TOTAL_PAYMENTS,
      params.enrollmentId,
      params.studentId,
      params.studioId,
    ],
    queryFn: () => getEnrollmentTotalPayments(params),
    enabled: options?.enabled ?? !!params.enrollmentId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
